import { handleActions } from 'redux-actions';
import { GridFilters, initialStateList } from './GridFiltersReducer';
import TransfersType from '../types/TransfersType';

const initialState = {
  transfers: { ...initialStateList },
  categories: [],
  accounts: [],
  currencies: [],
  rates: {},
};
export const Transfers = handleActions(
  {
    ...GridFilters,
    [TransfersType.actions.fetchTransfersCategories]: (state, { payload: { categories } }) => {
      return {
        ...state,
        categories,
      };
    },
    [TransfersType.actions.fetchTransfersAccounts]: (state, { payload: { accounts } }) => {
      return {
        ...state,
        accounts,
      };
    },
    [TransfersType.actions.fetchTransfersCurrencies]: (state, { payload: { currencies } }) => {
      return {
        ...state,
        currencies,
      };
    },
    [TransfersType.actions.fetchTransfersAccountRates]: (state, { payload: { rates } }) => {
      return {
        ...state,
        rates,
      };
    },
  },
  initialState
);

const getTransfers = (state) => state.Transfers;
export const getCategories = (state) => state.Transfers.categories;
export const getAccounts = (state) => state.Transfers.accounts;
export const getCurrencies = (state) => state.Transfers.currencies;
export const getRates = (state) => state.Transfers.rates;

export const getTransfersList = (state, list) => {
  const transfers = getTransfers(state);
  return transfers[list] || undefined;
};
